import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AttachmentIcon from '@material-ui/icons/Attachment';
import NoteIcon from '@material-ui/icons/NoteOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';
import { withRouter } from 'react-router-dom';
import GS from '../../grafsync/grafsync';
import SecondaryButton from '../SecondaryButton';
import { globalStyles, gstheme } from '../style/gstheme';

const styles = theme => {
    return Object.assign({
        importIcon: {
            height: 60,
            width: 60,
            color: theme.palette.grey[500]
        },
        importOuter: {
            backgroundColor: theme.palette.grey[100],
            marginBottom: '10px',
            borderRadius: '4px',
            textAlign: 'center',
            padding: '18px',
            height: '250px',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        importInner: {
            border: 'solid 1px ' + theme.palette.grey[500],
            backgroundColor: theme.palette.grey[100],
            borderRadius: '4px',
            textAlign: 'center',
            paddingTop: 30,
            height: '200px',
            paddingBottom: 20
        },
        showFile: {
            backgroundColor: theme.palette.grey[200],
            fontWeight: 500,
            borderRadius: '6px',
            color: gstheme.palette.primary.main,
            padding: '10px'
        },
        selectFile: {
            width: '180px',
            height: '50px',
            backgroundColor: 'white',
            color: '#50832C',
            border: 'solid 1px #97D700'
        }
    }, globalStyles);
};


class SelectFile extends React.Component {

    constructor(props) {
        super(props);
        const maxMB = GS.getActiveSubscriptionMaxImportSize();
        const maxSize = maxMB * 1024 * 1024;
        this.state = {
            dragging: false,
            maxMB,
            maxSize
        };
    }

    render() {

        const { classes, filename, onSelectFile, enableSpreadsheet, spreadsheetOnly, additionalExtensions } = this.props;
        const { maxSize, maxMB } = this.state;

        let fileFormats = "";
        if (!spreadsheetOnly) fileFormats += "application/rdf+xml, .ttl, .jsonld, .nt";
        if (additionalExtensions.length > 0) fileFormats += "," + additionalExtensions.join(", ");
        if (!spreadsheetOnly && enableSpreadsheet) fileFormats += ", ";
        if (enableSpreadsheet) fileFormats += ".csv, .tsv, .xlsx";

        return (
            <div>
                <div className={classes.importOuter}>
                    <Dropzone
                        accept={fileFormats}
                        maxSize={maxSize}
                        multiple={false}
                        onDrop={acceptedFiles => onSelectFile(acceptedFiles)}>
                        {({ getRootProps, getInputProps, rejectedFiles }) => {
                            const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize;
                            return (
                                <div data-test="drop-zone" {...getRootProps()} className={classes.importInner}>
                                    <NoteIcon className={classes.importIcon} />
                                    <div style={{ marginBottom: '30px', color: '#212121' }}>
                                    <Typography data-test="format-hint" variant="body2" style={{ marginBottom: 12, color: '#212121' }}>Files must be in one of the following formats: {!spreadsheetOnly && 'RDF/XML, JSON-LD, Turtle, N-Triples'}{!spreadsheetOnly && enableSpreadsheet && ', '}{enableSpreadsheet && 'CSV, TSV or XLSX'} (Max.&#160;{maxMB}MB)</Typography>
                                    {additionalExtensions.includes(".owl") &&
                                        <Typography data-test="format-owl" variant="body2" style={{ color: '#212121' }}>OWL files with a .owl extension can also be imported</Typography>
                                    }
                                    </div>
                                    <input {...getInputProps()} multiple={false} />
                                    <SecondaryButton dataTest="select-file">Select File</SecondaryButton>
                                    {isFileTooLarge &&
                                        <Typography data-test="file-too-large" variant="body2" style={{ marginTop: 10 }}>File too large. Maximum file size is {maxMB}MB.</Typography>
                                    }
                                </div>
                            );
                        }}
                    </Dropzone>
                </div>
                {filename &&
                    <Typography data-test="attached-file" className={classes.showFile} paragraph>
                        <AttachmentIcon style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                        {filename}
                    </Typography>
                }
            </div>
        );
    }
}

SelectFile.defaultProps = {
    enableSpreadsheet: false,
    spreadsheetOnly: false,
    additionalExtensions: []
};

SelectFile.propTypes = {
    classes: PropTypes.object,
    spreadsheetOnly: PropTypes.bool,
    enableSpreadsheet: PropTypes.bool,
    additionalExtensions: PropTypes.array,
    onSelectFile: PropTypes.func.isRequired,
    filename: PropTypes.string
};

export default withRouter(withStyles(styles)(SelectFile));